import { render, staticRenderFns } from "./CurrentOrder.vue?vue&type=template&id=6f479e7b"
import script from "./CurrentOrder.vue?vue&type=script&lang=js"
export * from "./CurrentOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports